(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-content"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAll(scope){
    (scope || document).querySelectorAll('[data-mn-slider]').forEach(function(slider){
      if (slider.dataset.mnInit === '1') return;
      slider.dataset.mnInit = '1';

      const track = slider.querySelector('[data-mn-track]');
      const slides = slider.querySelectorAll('[data-mn-slide]');
      const prev = slider.querySelector('[data-mn-prev]');
      const next = slider.querySelector('[data-mn-next]');

      const count = slides.length || 1;
      slider.setAttribute('data-mn-count', String(count));

      if(!track || count <= 1) return;

      let index = 0;

      function update(){
        track.style.transform = 'translate3d(' + (index * -100) + '%,0,0)';
      }

      prev && prev.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        index = (index - 1 + count) % count;
        update();
      });

      next && next.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        index = (index + 1) % count;
        update();
      });

      update();
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
